// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DatePlaceholder__container-ce8536 {
  position: sticky;
  top: -6px;
  flex: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: var(--message-bubble-max-width);
  margin: 14px auto 2px;
  align-self: center;
  pointer-events: none;
  z-index: 1;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.DatePlaceholder__text-fa17e9 {
  border-radius: 100px;
  padding: 4px 8px;
  margin: auto;
  white-space: nowrap;
  background: var(--average-background);
  color: var(--text-on-background);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  pointer-events: auto;
}

.DatePlaceholder__aligned-left-b14c0c {
  margin: 25px 56px 13px;
  align-self: flex-start;
}

.stuck {
  opacity: 0;
}

.stuck span {
  pointer-events: none;
}

#messages-container.is-scrolling-messages .stuck {
  opacity: 1;
}

#messages-container.is-scrolling-messages .stuck span {
  pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/DatePlaceholder/DatePlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AACF;;AAEA;EACE,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,gCAAA;EACA,4BAAA;EACA,8CAAA;EACA,oBAAA;AACF;;AAEA;EACE,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".container {\n  position: sticky;\n  top: -6px;\n  flex: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: var(--message-bubble-max-width);\n  margin: 14px auto 2px;\n  align-self: center;\n  pointer-events: none;\n  z-index: 1;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.text {\n  border-radius: 100px;\n  padding: 4px 8px;\n  margin: auto;\n  white-space: nowrap;\n  background: var(--average-background);\n  color: var(--text-on-background);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  pointer-events: auto;\n}\n\n.aligned-left {\n  margin: 25px 56px 13px;\n  align-self: flex-start;\n}\n\n:global .stuck {\n  opacity: 0;\n}\n\n:global .stuck span {\n  pointer-events: none;\n}\n\n:global #messages-container.is-scrolling-messages .stuck {\n  opacity: 1;\n}\n\n:global #messages-container.is-scrolling-messages .stuck span {\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DatePlaceholder__container-ce8536`,
	"text": `DatePlaceholder__text-fa17e9`,
	"aligned-left": `DatePlaceholder__aligned-left-b14c0c`,
	"alignedLeft": `DatePlaceholder__aligned-left-b14c0c`,
	"stuck": `stuck`,
	"messages-container": `messages-container`,
	"messagesContainer": `messages-container`,
	"is-scrolling-messages": `is-scrolling-messages`,
	"isScrollingMessages": `is-scrolling-messages`
};
module.exports = ___CSS_LOADER_EXPORT___;
